<div class="slide slide--hashtags" [style.--slide-accent-color]="titleColor">
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>
			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>

		<div class="slide__kpi" *ngIf="!isEmpty && topHashtag">
			<typography variant="h/1" class="slide__kpi-value">
				{{ topHashtag }}
			</typography>
			<div class="slide__kpi-label-row">
				<span class="slide__kpi-dot"></span>
				<typography variant="p/sm_regular" class="slide__kpi-label">
					{{ topHashtagLabel }}
				</typography>
			</div>
		</div>
	</div>

	<div class="slide__body" *ngIf="!isEmpty">
		<div class="slide__chart-panel">
			<typography variant="p/base_medium" class="slide__chart-title">
				Hashtag frequency
			</typography>
			<div class="slide__bars slide__chart-host">
				<ng-container *ngIf="!chartSwitch.block">
					<div class="slide__bar-row" *ngFor="let bar of bars">
						<span class="slide__bar-label">{{ bar.hashtag }}</span>
						<div class="slide__bar-track">
							<div
								class="slide__bar-fill"
								[style.width.%]="bar.widthPct"
								[style.background]="bar.color"
							></div>
							<span class="slide__bar-value">
								{{ bar.count | number }}
							</span>
						</div>
					</div>
				</ng-container>
				<app-report-chart-switch
					[state]="chartSwitch"
					[themeColor]="themeColor"
					[editorMode]="editorMode"
					(chartTypeChange)="chartTypeChange.emit($event)"
				></app-report-chart-switch>
			</div>
		</div>
	</div>

	<app-slide-no-data *ngIf="isEmpty"></app-slide-no-data>

	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<div class="slide__footer-tag">trending hashtags</div>
	</div>
</div>
